/**
 * package: com.inq.flash.client.chatskins
 * class: EmailMgr
 * root Object
 * @constructor
 */
com.inq.flash.client.chatskins.EmailMgr = function() {
};
$hxClasses['com.inq.flash.client.chatskins.EmailMgr'] = com.inq.flash.client.chatskins.EmailMgr;
/** @private @type {Array} */
com.inq.flash.client.chatskins.EmailMgr.__name__ = ["com","inq","flash","client","chatskins","EmailMgr"];

com.inq.flash.client.chatskins.EmailMgr.savedEmailInputTitle = null;

/**
 * _init
 *
 * $type TFun([],TEnum(Bool,[]))
 * private static function _init():Bool
 * @private
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.EmailMgr._init = function() {
	return true;
};


/**
 * init
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function init():Bool
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.EmailMgr.init = function() {
	com.inq.flash.client.chatskins.EmailMgr.emailButtonCap = Application.application.getButton("btnEmailCapture");
	com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap = Application.application.getMxmlItem("emailCapture");

	com.inq.flash.client.chatskins.EmailMgr.emailButton = Application.application.getButton("btnEmail");
	com.inq.flash.client.chatskins.EmailMgr.emailCanvas = Application.application.getMxmlItem("email");

	com.inq.flash.client.chatskins.EmailMgr.chatCanvas = Application.application.getMxmlItem("chat");
	com.inq.flash.client.chatskins.EmailMgr.tyCanvas = Application.application.getMxmlItem("thankYou");

	com.inq.flash.client.chatskins.EmailMgr.focusEmailField = com.inq.utils.Util.getConfig("focusEmailField", false);

	if(com.inq.flash.client.chatskins.EmailMgr.emailButtonCap != null && com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap != null) {
		com.inq.flash.client.chatskins.EmailMgr.setCaptureState(com.inq.flash.client.control.PersistenceManager.GetValue(EMAIL_MANAGER_CAPTURE_STATE, 0));
		if (com.inq.flash.client.chatskins.SkinControl.isInApplication("btnEmailCapture")) {
			Application.application.getButton("btnEmailCapture").addEventListener(com.inq.events.MouseEvent.CLICK,com.inq.flash.client.chatskins.EmailMgr.showEmailCaptureCanvas);
		}

		if (com.inq.flash.client.chatskins.SkinControl.isInApplication("btnSendEmailCapture")) {
			Application.application.getButton("btnSendEmailCapture").addEventListener(com.inq.events.MouseEvent.CLICK,com.inq.flash.client.chatskins.EmailMgr.actionBtnCaptureSendEmail);
		}
	}

	if(com.inq.flash.client.chatskins.EmailMgr.emailButton != null && com.inq.flash.client.chatskins.EmailMgr.emailCanvas != null) {
		com.inq.flash.client.chatskins.EmailMgr.setState(com.inq.flash.client.control.PersistenceManager.GetValue(EMAIL_MANAGER_STATE,0));
		if (com.inq.flash.client.chatskins.SkinControl.isInApplication("btnEmail")) {
			Application.application.getButton("btnEmail").addEventListener(com.inq.events.MouseEvent.CLICK,com.inq.flash.client.chatskins.EmailMgr.showEmailCanvas);
		}

		if (com.inq.flash.client.chatskins.SkinControl.isInApplication("btnSendEmail")) {
			Application.application.getButton("btnSendEmail").addEventListener(com.inq.events.MouseEvent.CLICK,com.inq.flash.client.chatskins.EmailMgr.actionBtnSendEmail);
		}

	}
	return true;
};


/**
 * showEmailCaptureCanvas
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => false }],TEnum(Bool,[]))
 * public static function showEmailCaptureCanvas(me:MouseEvent):Bool
 * @public
 * @static
 * @param {com.inq.events.MouseEvent}  me
 * @return {boolean}
 */
com.inq.flash.client.chatskins.EmailMgr.showEmailCaptureCanvas = function(me) {
	com.inq.flash.client.chatskins.EmailMgr.setCaptureState(com.inq.flash.client.chatskins.EmailMgr.SHOW_ALL_STATE);
	return false;
};


/**
 * showEmailCanvas
 *
 * 	Display Email Canvas.
 *
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.EmailMgr.showEmailCanvas = function () {
	/*
	 * RTDEV-18119
	 * Added test for isConnectionAccepted so that we only show email canvas when we have
	 * both the connection and the agent has accepted the chat.
	 * Also test for VA. If it is a VA chat, enable email button when the chat communication is established regardless
	 * whether the agent has accepted the chat.
	 * RTDEV-21355
	 * Added test for isEmailCanvasAndButtonVisible to prevent repeated function call of updateEmailInputTitle()
	 * so we do nothing at all if email canvas and button have already been visible
	 */
	var app = Application.application;
	if (!app.isConnected() || (!app.isAgentAssigned() && !app.isVirtualAgent()) || com.inq.flash.client.chatskins.EmailMgr.isEmailCanvasAndButtonVisible()) {
		return false;
	}

	if (com.inq.utils.Capabilities.isIpad()) {
		return com.inq.flash.client.chatskins.EmailMgr.showEmailCanvasIpad();
	}
	com.inq.flash.client.chatskins.EmailMgr.modalEmailCanvas();
	/**
	 *  RTDEV-8711
	 *  @description On firefox jaws was not releasing the focus from the email button.
	 *  So i (Mithun) added code to blur the focus on the email input img and also added
	 *  a timer before setting the email setvisible true.
	 *  From Mithen, this happens on IE also, and added condition accordingly.
	 */
	if (com.inq.utils.Capabilities.isMobile()) {
		com.inq.flash.client.chatskins.EmailMgr.setState(com.inq.flash.client.chatskins.EmailMgr.SHOW_ALL_STATE);
		var ti = Application.application.getTextInput("emailInput");
		if (ti != null) {
			if(com.inq.utils.Capabilities.isIphone()) {
				try {
					ti._input.style.minHeight = ti._div.style.height;
				} catch (errWhileSetTiHeight) { /* ignore and continue */ }
			}
			ti.setFocus(true);
		}
	} else {
		/* RTDEV-11268 On Firefox with xframe, JAWS cannot access email transcript form elements correctly
		*  Without time delay.
		*  RTDEV-10950 If this delay is used in a chat without xframe, page title is read by JAWS
		* */
		if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1 && Application.application.getXFrameItems().length > 0) {
			window.setTimeout(function () {
				com.inq.flash.client.chatskins.EmailMgr.setState(com.inq.flash.client.chatskins.EmailMgr.SHOW_ALL_STATE);
				var ti = Application.application.getTextInput("emailInput");
				if (ti != null) {
					com.inq.flash.client.chatskins.EmailMgr.updateEmailInputTitle();
					ti.setFocus(true);
				}
			}, 200);
		}
		else {
			com.inq.flash.client.chatskins.EmailMgr.setState(com.inq.flash.client.chatskins.EmailMgr.SHOW_ALL_STATE);
			var ti = Application.application.getTextInput("emailInput");
			if (ti != null && ti._visible === true) {
				com.inq.flash.client.chatskins.EmailMgr.updateEmailInputTitle();
				ti.setFocus(true);
			}
			else {
				var cti = Application.application.getTextInput("txtInput");
				if (cti != null) {
					cti.setFocus(true);   // Make the focus doesn't goto page title.
				}
				window.setTimeout(function () {
					var ti = Application.application.getTextInput("emailInput");
					if (ti != null) {
						com.inq.flash.client.chatskins.EmailMgr.updateEmailInputTitle();
						ti.setFocus(true);
					}
				}, 200);
			}
		}
	}
};

/**
 * 	Checks the state for visibility of Email Canvas and Email Button
 *
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.EmailMgr.isEmailCanvasAndButtonVisible = function () {
	return com.inq.flash.client.chatskins.EmailMgr.getState() === com.inq.flash.client.chatskins.EmailMgr.SHOW_ALL_STATE;
};

/**
 * showEmailCanvasIpad
 *
 * 	Display Email Canvas.
 *
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.EmailMgr.showEmailCanvasIpad = function(me) {
	window.setTimeout( function() {
		com.inq.flash.client.chatskins.EmailMgr.setState(com.inq.flash.client.chatskins.EmailMgr.SHOW_ALL_STATE);
		var ti = Application.application.getTextInput("emailInput");
		if(ti != null) {
			ti.setFocus(true)
		}
	}, 1000);
	com.inq.flash.client.chatskins.EmailMgr.modalEmailCanvas();

	return false;
};

/**
 *  modalEmailCanvas
 *
 * 	Turn Email Canvas as modal window so Screen Reader focus stay in Email Canvas only.
 *
 * @public
 * @static
 * @return
 */
com.inq.flash.client.chatskins.EmailMgr.modalEmailCanvas = function () {
	com.inq.aria.ModalWindow.modalEmailCanvas();
};

/**
 * unModalEmailCanvas
 *
 *    Remove modal window on Email Canvas.
 *    each attribute change is in try catch block so the process can move on next item.
 *
 * @public
 * @static
 * @return
 */
com.inq.flash.client.chatskins.EmailMgr.unModalEmailCanvas = function () {
	com.inq.aria.ModalWindow.unModalEmailCanvas();
};


/**
 * setCaptureState
 *
 * $type TFun([{ name => state, t => TInst(Int,[]), opt => false }],TEnum(Void,[]))
 * private static function setCaptureState( state:Int ):Void
 * @private
 * @static
 * @param {number}  state
 * @return {void}
 */
com.inq.flash.client.chatskins.EmailMgr.setCaptureState = function(state) {
	/** @type {number} */
	var chatHeight = 0;
	if(com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap != null && com.inq.flash.client.chatskins.EmailMgr.emailButtonCap != null) {
		switch(state) {
			case com.inq.flash.client.chatskins.EmailMgr.SHOW_BUTTON_STATE:
				com.inq.flash.client.chatskins.EmailMgr.emailButtonCap.setVisible(true);
				com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap.setVisible(false);
				break;
			case com.inq.flash.client.chatskins.EmailMgr.SHOW_ALL_STATE:
				if(!com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap.getVisible()) {
					if(com.inq.flash.client.chatskins.EmailMgr.emailCanvas != null && com.inq.flash.client.chatskins.EmailMgr.emailCanvas.getVisible()) {
						chatHeight += Std.parseInt(com.inq.flash.client.chatskins.EmailMgr.emailCanvas.getStyle("top")) + com.inq.flash.client.chatskins.EmailMgr.emailCanvas.getHeight() + com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap.getHeight();
						com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap.setStyle("top","" + Std.string(Std.parseInt(com.inq.flash.client.chatskins.EmailMgr.emailCanvas.getStyle("top")) + com.inq.flash.client.chatskins.EmailMgr.emailCanvas.getHeight()));
					} else chatHeight += Std.parseInt(com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap.getStyle("top")) + com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap.getHeight();

					com.inq.flash.client.chatskins.EmailMgr.chatCanvas.setStyle("top","" + chatHeight);

					//if(com.inq.flash.client.chatskins.EmailMgr.tyCanvas != null) com.inq.flash.client.chatskins.EmailMgr.tyCanvas.setStyle("top","" + chatHeight);

					com.inq.flash.client.chatskins.EmailMgr.emailButtonCap.setVisible(true);
					com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap.setVisible(true);
				}
				break;
			case com.inq.flash.client.chatskins.EmailMgr.SHOW_NONE_STATE:
				/** @type {number} */
				var emailCanvasCapTop = emailCanvasCapTop = Std.parseInt(com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap.getStyle("top"));
				if(com.inq.flash.client.chatskins.EmailMgr.emailCanvas != null && com.inq.flash.client.chatskins.EmailMgr.emailCanvas.getVisible()) {
					/** @type {number} */
					var emailCanvasTop = Std.parseInt(com.inq.flash.client.chatskins.EmailMgr.emailCanvas.getStyle("top"));
					if(emailCanvasCapTop < emailCanvasTop) {
						com.inq.flash.client.chatskins.EmailMgr.emailCanvas.setStyle("top",emailCanvasCapTop);
						chatHeight += emailCanvasCapTop + com.inq.flash.client.chatskins.EmailMgr.emailCanvas.getHeight();
					} else chatHeight += emailCanvasCapTop;
				} else chatHeight += emailCanvasCapTop;

				com.inq.flash.client.chatskins.EmailMgr.chatCanvas.setStyle("top","" + chatHeight);

				//if(com.inq.flash.client.chatskins.EmailMgr.tyCanvas != null) com.inq.flash.client.chatskins.EmailMgr.tyCanvas.setStyle("top","" + chatHeight);
				com.inq.flash.client.chatskins.EmailMgr.emailButtonCap.setVisible(false);
				com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap.setVisible(false);
				break;
			default:
				com.inq.flash.client.chatskins.EmailMgr.emailButtonCap.setVisible(true);
				com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap.setVisible(false);
		}
		com.inq.flash.client.control.PersistenceManager.SetValue(EMAIL_MANAGER_CAPTURE_STATE, state);
	}
};


/**
 * setState
 *
 * $type TFun([{ name => state, t => TInst(Int,[]), opt => false }],TEnum(Void,[]))
 * private static function setState( state:Int ):Void
 * @private
 * @static
 * @param {number}  state
 * @return {void}
 */
com.inq.flash.client.chatskins.EmailMgr.setState = function(state) {
	/** @type {number} */
	var chatHeight = 0;
	if(com.inq.flash.client.chatskins.EmailMgr.emailCanvas != null && com.inq.flash.client.chatskins.EmailMgr.emailButton != null) {
		switch(state) {
			case com.inq.flash.client.chatskins.EmailMgr.SHOW_BUTTON_STATE:
				com.inq.flash.client.chatskins.EmailMgr.emailButton.setVisible(true);
				com.inq.flash.client.chatskins.EmailMgr.emailCanvas.setVisible(false);
				break;
			case com.inq.flash.client.chatskins.EmailMgr.SHOW_ALL_STATE:
				if(!com.inq.flash.client.chatskins.EmailMgr.emailCanvas.getVisible()) {
					if(com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap != null && com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap.getVisible()) {
						chatHeight += Std.parseInt(com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap.getStyle("top")) + com.inq.flash.client.chatskins.EmailMgr.emailCanvas.getHeight() + com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap.getHeight();
						com.inq.flash.client.chatskins.EmailMgr.emailCanvas.setStyle("top","" + Std.string(Std.parseInt(com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap.getStyle("top")) + com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap.getHeight()));
					} else chatHeight += Std.parseInt(com.inq.flash.client.chatskins.EmailMgr.emailCanvas.getStyle("top")) + com.inq.flash.client.chatskins.EmailMgr.emailCanvas.getHeight();
					if(com.inq.flash.client.chatskins.EmailMgr.emailCanvas.getStyle("top")!=null) {
						com.inq.flash.client.chatskins.EmailMgr.chatCanvas.setStyle("top", "" + chatHeight);
					}

					//if(com.inq.flash.client.chatskins.EmailMgr.tyCanvas != null) com.inq.flash.client.chatskins.EmailMgr.tyCanvas.setStyle("top","" + chatHeight);

					com.inq.flash.client.chatskins.EmailMgr.emailButton.setVisible(true);
					com.inq.flash.client.chatskins.EmailMgr.emailCanvas.setVisible(true);
					if(com.inq.flash.client.chatskins.EmailMgr.focusEmailField){
						var emailInputCapture = Application.application.getMxmlItem("emailInput");
						emailInputCapture.setFocus();
					}
				}
				break;
			case com.inq.flash.client.chatskins.EmailMgr.SHOW_NONE_STATE:
				/** @type {number} */
				var emailCanvasTop = Std.parseInt(com.inq.flash.client.chatskins.EmailMgr.emailCanvas.getStyle("top"));
				if(com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap != null && com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap.getVisible()) {
					/** @type {number} */
					var emailCanvasCapTop = Std.parseInt(com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap.getStyle("top"));
					if(emailCanvasTop < emailCanvasCapTop) {
						com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap.setStyle("top",emailCanvasTop);
						chatHeight += emailCanvasTop + com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap.getHeight();
					} else chatHeight += emailCanvasTop;
				} else chatHeight += emailCanvasTop;
				if(com.inq.flash.client.chatskins.EmailMgr.emailCanvas.getStyle("top")!=null) {
					com.inq.flash.client.chatskins.EmailMgr.chatCanvas.setStyle("top", "" + chatHeight);
				}

				//if(com.inq.flash.client.chatskins.EmailMgr.tyCanvas != null && emailCanvasTop != null)
				//	com.inq.flash.client.chatskins.EmailMgr.tyCanvas.setStyle("top","" + chatHeight);

				com.inq.flash.client.chatskins.EmailMgr.emailButton.setVisible(false);
				com.inq.flash.client.chatskins.EmailMgr.emailCanvas.setVisible(false);
				break;
			default:
				com.inq.flash.client.chatskins.EmailMgr.emailButton.setVisible(true);
				com.inq.flash.client.chatskins.EmailMgr.emailCanvas.setVisible(false);
		}
		com.inq.flash.client.control.PersistenceManager.SetValue(EMAIL_MANAGER_STATE, state);
	}
};

/**
 * Returns the current state of EmailMgr in accordance with stored value.
 *
 * @return {String}
 */
com.inq.flash.client.chatskins.EmailMgr.getState = function () {
    return com.inq.flash.client.control.PersistenceManager.GetValue(EMAIL_MANAGER_STATE);
};

/**
 * actionBtnCaptureSendEmail
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => false }],TEnum(Bool,[]))
 * public static function actionBtnCaptureSendEmail(me:MouseEvent):Bool
 * @public
 * @static
 * @param {com.inq.events.MouseEvent}  me
 * @return {boolean}
 */
com.inq.flash.client.chatskins.EmailMgr.actionBtnCaptureSendEmail = function(me) {
	if(com.inq.flash.client.chatskins.SkinControl.isInApplication("emailInputCapture")) {
		/** @type {com.inq.ui.TextInput} */
		var emailInputCapture = Application.application.getMxmlItem("emailInputCapture");
		/** @type {string} */
		var emailAddressCapture = emailInputCapture._getInput();
		try {
			emailAddressCapture = StringTools.trim(emailAddressCapture);
			if(emailAddressCapture.length != 0) {
				com.inq.flash.client.control.FlashPeer.captureEmailAddress(emailAddressCapture);
				com.inq.flash.client.chatskins.EmailMgr.hideEmailButton();
			}
		} catch( e ) {
		}
	}
	return false;
};


/**
 * actionBtnSendEmail
 *
 * @public
 * @static
 * @param {com.inq.events.MouseEvent} ev
 * @return {boolean}
 */
com.inq.flash.client.chatskins.EmailMgr.actionBtnSendEmail = function (ev) {
	if (com.inq.flash.client.chatskins.SkinControl.isInApplication("emailInput")) {
		/** @type {com.inq.ui.TextInput} */
		var emailInput = Application.application.getMxmlItem("emailInput");
		var _aria = com.inq.aria.AriaMsg;
		/** @type {string} */
		var emailAddress = emailInput._getInput();
		try {
			emailAddress = StringTools.trim(emailAddress);
			/**
			 * @see http://jira.touchcommerce.com/browse/RTDEV-28765
			 * @description anything.any_thing@anything.some.any
			 */
			if (emailAddress.length != 0 && /^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9-]+\.)+[A-Za-z]{2,}$/.test(emailAddress)) {
				com.inq.flash.client.control.FlashPeer.requestTranscript(emailAddress, com.inq.flash.client.control.FlashVars.getCustomerName());
				com.inq.flash.client.chatskins.EmailMgr.saveRequestedStatus();
				/**
				 * http://jira.touchcommerce.com/browse/RTDEV-8631
				 * @type {com.inq.ui.Text}
				 */
				var successItem = Application.application.getMxmlItem("SuccessSend");
				if(successItem) {
					successItem.setVisible(true);
					var aBtn = Application.application.getButton("btnCloseEmail")
					if (aBtn != null) {
						aBtn.setImageFocus();
					}
				} else {
					com.inq.flash.client.chatskins.EmailMgr.hideEmailButton();

					com.inq.flash.client.chatskins.EmailMgr.unModalEmailCanvas();

					var txtInput = com.inq.flash.client.chatskins.SkinControl.getTextInputField();
					txtInput.setFocus();
				}
				/**
				 * @see RTDEV-11680
				 */
				if(com.inq.utils.Util.isIE) {
					setTimeout(function() {
						_aria.addAriaMsg(com.inq.flash.client.chatskins.EmailMgr.SUCCESS_MSG_PART1, com.inq.flash.client.chatskins.ChatTextArea.SYSTEM, true);
						setTimeout(function() {
							_aria.addAriaMsg(com.inq.flash.client.chatskins.EmailMgr.SUCCESS_MSG, com.inq.flash.client.chatskins.ChatTextArea.SYSTEM, true);
						}, 1E3);
					},1500);

				} else if (com.inq.utils.Capabilities.isIphone()) {
					var delay = 700;

					if (com.inq.utils.Capabilities.isSafariVersion11() || com.inq.utils.Capabilities.isChromeiOS11()) {
						delay = 300;
					}

					setTimeout(function () {
						com.inq.aria.AriaMsg.clearAriaMsg();
						_aria.addAriaMsg(com.inq.flash.client.chatskins.EmailMgr.SUCCESS_MSG, com.inq.flash.client.chatskins.ChatTextArea.SYSTEM, true);
					}, delay);
				} else {
					setTimeout(function () {
						_aria.addAriaMsg(com.inq.flash.client.chatskins.EmailMgr.SUCCESS_MSG, com.inq.flash.client.chatskins.ChatTextArea.SYSTEM, true);
					}, 2000);
				}

			} else {
				var failedItem = Application.application.getMxmlItem("FailedSend");
				var failedMsg = com.inq.flash.client.chatskins.EmailMgr.FAIL_MSG;
				if(failedItem){
					failedMsg = failedItem._div ? failedItem._div.innerText : failedMsg;
				}

				if (!com.inq.utils.Capabilities.isIphone() && !com.inq.utils.Util.isIE ) {
					_aria.addAriaMsg(failedMsg, com.inq.flash.client.chatskins.ChatTextArea.SYSTEM, true);
				}
				var emailInputCapture = Application.application.getMxmlItem("emailInput");
				emailInputCapture.setFocus(true);

				/**
				 * http://jira.touchcommerce.com/browse/RTDEV-8630
				 */
				if(failedItem){
					failedItem.setVisible(true);
				}

				/* RTDEV-10310; ADA, make email transcript request fail message spoken clearly and does everytime */
				if (com.inq.utils.Capabilities.isIphone() || com.inq.utils.Util.isIE) {
					setTimeout(function () {
						_aria.addAriaMsg(com.inq.flash.client.chatskins.EmailMgr.FAIL_MSG_PART1, com.inq.flash.client.chatskins.ChatTextArea.SYSTEM, true);
						setTimeout(function () {
							_aria.addAriaMsg(failedMsg, com.inq.flash.client.chatskins.ChatTextArea.SYSTEM, true);
						}, 1000);
					}, 1500);
				}
			}
		} catch (e) {
		}
	}
	if (!com.inq.utils.Capabilities.isMobile()) {
		com.inq.flash.client.chatskins.EmailMgr.restoreEmailInputTitle();
	}
	return false;
};

/**
 * actionCancelEmail
 *
 *   Cancel and close eamil
 */
com.inq.flash.client.chatskins.EmailMgr.actionCancelEmail = function() {
	com.inq.flash.client.chatskins.EmailMgr.unModalEmailCanvas();
	com.inq.flash.client.chatskins.EmailMgr.hideEmailButton();
	var successSendItem = Application.application.getMxmlItem("SuccessSend");
	var txtInput = com.inq.flash.client.chatskins.SkinControl.getTextInputField();

    /** @type {Function} */
	var setFocusFn = function(force) {
        if (!successSendItem || successSendItem && !successSendItem.getVisible()) {
            com.inq.flash.client.chatskins.EmailMgr.setState(com.inq.flash.client.chatskins.EmailMgr.SHOW_BUTTON_STATE);
            com.inq.flash.client.chatskins.EmailMgr.emailButton.setImageFocus();
        } else {
            txtInput.setFocus(force);
        }
    };
	/**
	 * @see http://jira.touchcommerce.com/browse/RTDEV-9120
	 * @description issue is fixed by adding making the txtInput visible false and after a delay making the  visible again
	 * this way voice over won't miss reading the inputbox message
	 */
	if(com.inq.utils.Capabilities.isIpad()) {
		txtInput.setVisible(false);
		com.inq.utils.Timer.delay(function(){
			txtInput.setVisible(true);
			/**
			 * @see RTDEV-12146
			 * Bug: Email button disappears after the email modal window is closed.
			 * Fix:	Explicitly do a setState() to display the email button, because the "txtInput.setVisible(false)" hides all the buttons /input box and the
			 * DOM does not yet recognize the change during the "txtInput.setVisible(true). Check the ticket for detailed analysis.
			 */
			setFocusFn(true);
		},1000);
	} else {
		if (com.inq.utils.Capabilities.isIphone()) {
			txtInput.setVisible(false);
			txtInput.setVisible(true);
			try{
				com.inq.aria.AriaMsg(txtInput._introduction, com.inq.flash.client.chatskins.ChatTextArea.SYSTEM, true);
			} catch (er) {}
		}
        /**
         * email button should displayed when user cancel email modal , exception to that if success canvas is visible.
         */
        setFocusFn(true);
        if (!com.inq.utils.Capabilities.isMobile()) {
			com.inq.flash.client.chatskins.EmailMgr.restoreEmailInputTitle();
		}
	}
};

/**
 * saveRequestedStatus
 *
 *   save email transcript request into persistent storage
 */
com.inq.flash.client.chatskins.EmailMgr.saveRequestedStatus = function() {
	com.inq.flash.client.control.PersistenceManager.SetValue(com.inq.flash.client.chatskins.EmailMgr.REQUEST_STATUS_COOKIE_NAME,
		com.inq.flash.client.chatskins.EmailMgr.REQUEST_STATUS_REQUESTED);
};

/**
 * getRequestStatus
 *
 *   get email transcript request from persistent storage
 */
com.inq.flash.client.chatskins.EmailMgr.getRequestStatus = function() {
	  return com.inq.flash.client.control.PersistenceManager.GetValue(com.inq.flash.client.chatskins.EmailMgr.REQUEST_STATUS_COOKIE_NAME,
		  com.inq.flash.client.chatskins.EmailMgr.REQUEST_STATUS_DEFAULT );
};

/**
 * RTDEV-15393
 * Update email transcript CATO message to include the text for title and description.
 */
com.inq.flash.client.chatskins.EmailMgr.updateEmailInputTitle = function() {
    /**
	 * Appends the text of container with keyId to the title attribute of the specified element
	 *
     * @param {HTMLElement} element - element to which appending text to its title attribute
     * @param {String} keyId - the id of the requested mxml item whose text will be added
	 * @return {void}
     */
    var appendTextToTitle = function (element, keyId) {
        var container = Application.application.getMxmlItem(keyId);
        if (container && container.getStyle('text')) {
            if (element.title) {
                element.title = element.title + " " + container.getStyle('text');
            } else {
                element.title = container.getStyle('text');
            }
        }
    };

	var ti = Application.application.getTextInput("emailInput");
	if (ti) {
        com.inq.flash.client.chatskins.EmailMgr.savedEmailInputTitle = ti._text.title;
        appendTextToTitle(ti._text, "EmailTitle");
        appendTextToTitle(ti._text, "EmailDescription");
    }
};

/**
 * RTDEV-15393
 * Restore the email input title to its original value saved when <updateEmailInputTitle function was called.
 * This function will be called when the Email modal is closed.
 */
com.inq.flash.client.chatskins.EmailMgr.restoreEmailInputTitle = function() {
	var ti = Application.application.getTextInput("emailInput");
	if (ti && com.inq.flash.client.chatskins.EmailMgr.savedEmailInputTitle) {
		ti._text.title = com.inq.flash.client.chatskins.EmailMgr.savedEmailInputTitle;
		com.inq.flash.client.chatskins.EmailMgr.savedEmailInputTitle = null;
	}
}

com.inq.flash.client.chatskins.EmailMgr.hideEmailButton = function () {
	com.inq.flash.client.chatskins.EmailMgr.setState(com.inq.flash.client.chatskins.EmailMgr.SHOW_NONE_STATE);
};

/** @type {com.inq.flash.client.chatskins.EmailMgr} */
com.inq.flash.client.chatskins.EmailMgr.prototype.__class__ = com.inq.flash.client.chatskins.EmailMgr;
/** @private @type {number} */
com.inq.flash.client.chatskins.EmailMgr.SHOW_BUTTON_STATE = 0;

/** @private @type {number} */
com.inq.flash.client.chatskins.EmailMgr.SHOW_ALL_STATE = 1;

/** @private @type {number} */
com.inq.flash.client.chatskins.EmailMgr.SHOW_NONE_STATE = 2;

/** @private @type {boolean} */
com.inq.flash.client.chatskins.EmailMgr._initialized = com.inq.flash.client.chatskins.EmailMgr._init();

/** @private @type {com.inq.ui.Button} */
com.inq.flash.client.chatskins.EmailMgr.emailButton = null;

/** @private @type {com.inq.ui.Button} */
com.inq.flash.client.chatskins.EmailMgr.emailButtonCap = null;

/** @private @type {com.inq.ui.Canvas} */
com.inq.flash.client.chatskins.EmailMgr.emailCanvas = null;

/** @private @type {com.inq.ui.Canvas} */
com.inq.flash.client.chatskins.EmailMgr.emailCanvasCap = null;

/** @private @type {com.inq.ui.Canvas} */
com.inq.flash.client.chatskins.EmailMgr.chatCanvas = null;

/** @private @type {com.inq.ui.Canvas} */
com.inq.flash.client.chatskins.EmailMgr.tyCanvas = null;

/** @private @type {array} */
com.inq.flash.client.chatskins.EmailMgr.ariaDivsHidden = null;

/** @private @type {number} */
com.inq.flash.client.chatskins.EmailMgr.hasRequested = null;
/** @private @type {string} */
com.inq.flash.client.chatskins.EmailMgr.REQUEST_STATUS_COOKIE_NAME = "tsquest";
/** @private @type {number} */
com.inq.flash.client.chatskins.EmailMgr.REQUEST_STATUS_REQUESTED = 1;
/** @private @type {number} */
com.inq.flash.client.chatskins.EmailMgr.REQUEST_STATUS_DEFAULT = 0;

/** @static @type {String} */
com.inq.flash.client.chatskins.EmailMgr.FAIL_MSG_PART1 = "Validation Fail";
com.inq.flash.client.chatskins.EmailMgr.FAIL_MSG = "Fail to send email address for chat transcript";

/** @static @type {String} */
com.inq.flash.client.chatskins.EmailMgr.SUCCESS_MSG_PART1 = "Validation Success";
com.inq.flash.client.chatskins.EmailMgr.SUCCESS_MSG = "Your request has been sent.  Your transcript will be sent to you when your chat is completed.";
